import { toastError } from '@/components/Toast';
import { closeLoader, openLoader } from '@/store/actions/LoaderAction';
import baseApi from '@/store/api/baseApi';
import { Types } from '@/store/types';

export const myDashboardApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getProductList: builder.mutation({
			query: ({ params, body }) => ({
				url: '/product/search',
				method: 'POST',
				params,
				body
			})
		}),
		getTaskDashboardFilterById: builder.query({
			query: ({ id }) => ({
				url: `/task-dashboard-filter/${id}`,
				method: 'GET'
			})
		}),
		getFilterOptions: builder.mutation({
			query: ({ params, body }) => ({
				url: '/product/filter-options',
				method: 'POST',
				params,
				body
			}),
			async onQueryStarted(args, { queryFulfilled, dispatch }) {
				try {
					dispatch(openLoader());
					const { data } = await queryFulfilled;
					dispatch({
						type: Types.STORE_DEPENDENT_FILTER_LIST,
						payload: { responseData: data, filterListPage: 'PRODUCT_LIST' }
					});
				} catch (error) {
					toastError(error?.data?.message || 'Something went wrong!');
				} finally {
					dispatch(closeLoader());
				}
			}
		}),
		getListViewResponse: builder.mutation({
			query: ({ id, params, body }) => ({
				url: `/task-dashboard-filter-logic-executor/listview/${id}`,
				method: 'POST',
				params,
				body
			})
		}),
		updateProductPriority: builder.mutation({
			query: ({ productId, body }) => ({
				url: `product/${productId}/set-task-priority?priority=${body?.priority}`,
				method: 'PUT',
				body
			})
		}),
		getBuyerFeedback: builder.mutation({
			query: ({ id, buyerFeedback }) => ({
				url: `/sample/item/${id}/update-buyer-feedback?buyerFeedback=${encodeURIComponent(buyerFeedback ?? '')}`,
				method: 'POST'
			})
		}),
		getFabricStatus: builder.mutation({
			query: ({ id, fabricStatus }) => ({
				url: `/sample/item/${id}/update-fabric-status?fabricStatus=${encodeURIComponent(fabricStatus ?? '')}`,
				method: 'POST'
			})
		}),
		getRemarks: builder.mutation({
			query: ({ id, remarks }) => ({
				url: `/sample/item/${id}/update-remarks?remarks=${encodeURIComponent(remarks ?? '')}`,
				method: 'POST'
			})
		}),
		quantityWiseUpdatePrice: builder.mutation({
			query: ({ body }) => ({
				url: `quantity-wise-cost/update-price`,
				method: 'POST',
				body
			})
		}),
		updateQouteEod: builder.mutation({
			query: ({ body }) => ({
				url: '/quote/eod',
				method: 'PUT',
				body
			})
		}),
		issueRemarks: builder.mutation({
			query: ({ id, remarks }) => ({
				url: `/issue/${id}/remarks?content=${encodeURIComponent(remarks ?? '')}`,
				method: 'PUT'
			})
		}),
		generalRemarks: builder.mutation({
			query: ({ id, remarks }) => ({
				url: `/product/collection-remarks/${id}?remarks=${encodeURIComponent(remarks ?? '')}`,
				method: 'POST'
			})
		}),
		graphicsAndThreeDRemarks: builder.mutation({
			query: ({ id, remarks }) => ({
				url: `/product-development-journey-instance/${id}/update-remarks?content=${encodeURIComponent(remarks ?? '')}`,
				method: 'PUT'
			})
		})
	})
});

export const {
	useGetProductListMutation,
	useGetTaskDashboardFilterByIdQuery,
	useGetFilterOptionsMutation,
	useGetListViewResponseMutation,
	useUpdateProductPriorityMutation,
	useGetBuyerFeedbackMutation,
	useGetFabricStatusMutation,
	useGetRemarksMutation,
	useQuantityWiseUpdatePriceMutation,
	useUpdateQouteEodMutation,
	useIssueRemarksMutation,
	useGeneralRemarksMutation,
	useGraphicsAndThreeDRemarksMutation
} = myDashboardApi;
